module.exports = __webpack_public_path__ + "img/btn-logout-en.3e28fb1d.png";